const naturezaTributacao = {
  SIMPLES_NACIONAL: '1 - Simples Nacional',
  FIXO: '2 - Fixo',
  DEPOSITO_EM_JUIZO: '3 - Depósito em Juízo',
  EXIBILIDADE_DECISAO_JUDICIAL: '4 - Exigibilidade suspensa por decisão judicial',
  EXIBILIDADE_PROCE_ADM: '5 - Exigibilidade suspensa por procedimento administrativo',
  ISENCAO_PARCIAL: '6 - Isenção parcial',
};

export default naturezaTributacao;
